import { render, staticRenderFns } from "./LastTicketsWrapper.vue?vue&type=template&id=4c23867d"
import script from "./LastTicketsWrapper.vue?vue&type=script&lang=js"
export * from "./LastTicketsWrapper.vue?vue&type=script&lang=js"
import style0 from "./LastTicketsWrapper.vue?vue&type=style&index=0&id=4c23867d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports